import React, { useContext, useEffect, useState } from "react";
import {
  Dropdown,
  ItemTitle,
  List,
  ListItem,
  Navigation,
  NavItem,
} from "./alphabet.styles";
import { OpredelitelContext } from "../../context";
import { useElementVisibility } from "../../helpers";

const Alphabet = () => {
  const { blocks, refMap } = useContext(OpredelitelContext);
  const [data, setData] = useState({});
  const [hoveredLetter, setHoveredLetter] = useState(null); // Состояние для текущей буквы, на которую навели
  const [isVisible, setIsVisible] = useState(false);

  const groupedByLetter = blocks.reduce((acc, item) => {
    const firstLetter = item.title[0];
    if (!acc[firstLetter]) {
      acc[firstLetter] = [];
    }
    acc[firstLetter].push(item);
    return acc;
  }, {});

  // Пересобираем объект с нужным порядком ключей
  const sortedGroupedByLetter = {};
  Object.keys(groupedByLetter).forEach((key) => {
    sortedGroupedByLetter[key] = key;
  });

  const renderDropdown = (item) => {
    return (
      <Dropdown>
        {data[item].map((ul) => (
          <div key={ul.id}>
            <ItemTitle to={`/opredelitel/${ul.id}`}>{ul.title}</ItemTitle>
            <List>
              {ul.lists?.map((li, index) => (
                <ListItem key={index}>{li.title}</ListItem>
              ))}
            </List>
          </div>
        ))}
      </Dropdown>
    );
  };

  useEffect(() => {
    setData(groupedByLetter);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [blocks]);

  useElementVisibility(
    refMap,
    "alphabet_navigator",
    (isVisible) => setIsVisible(isVisible), // Устанавливаем видимость через callback
    20, // Отступ в 20px
  );

  return (
    <Navigation $isVisible={isVisible}>
      {Object.keys(sortedGroupedByLetter).map((letter) => {
        return (
          <NavItem
            $isActive={hoveredLetter === letter}
            key={letter}
            onMouseEnter={() => setHoveredLetter(letter)}
            onMouseLeave={() => setHoveredLetter(null)}
            onClick={() =>
              setHoveredLetter(hoveredLetter === letter ? null : letter)
            }
          >
            <span>{letter}</span>
            {hoveredLetter === letter && renderDropdown(letter)}
          </NavItem>
        );
      })}
    </Navigation>
  );
};

export default Alphabet;
